import styled, { css } from "styled-components";
import { convert } from "../helpers";

const Heading = styled.h1`
  font-size: 2em;
  ${props => props.clock && css`
    font-size: 3.75em;
    font-weight: 200;
    text-shadow: rgba(255, 255, 255, 0.3) 0px 7px 25px;
  `}
  color: ${props => props.below60 || props.theme.color};
`;

const Clock = ({ seconds, clockStatus }) => {
  return (
    <div>
      <Heading>{clockStatus}</Heading>
      <Heading clock below60={seconds <= 60 ? "#f00" : ""}>{convert(seconds)}</Heading>
    </div>
  );
};

export default Clock;